import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { OrbitPanel, OrbitStatus, OrbitEmptyState } from "@/components/orbit";

const fmt = d => d ? new Date(d).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "medium" }) : "—";

export default function LogsTab() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/integrations/inpulse/logs").then(r => setRows(r.data)).catch(() => setRows([])); }, []);
  return (
    <OrbitPanel title="Journal des opérations" hint="aucun secret n'est journalisé" testid="inpulse-logs">
      <table className="o-table" data-testid="logs-table"><thead><tr><th>Date</th><th>Opération</th><th>Endpoint</th><th>Durée</th><th>Statut</th><th>Éléments</th><th>Erreur</th></tr></thead>
        <tbody>{(rows || []).map(l => <tr key={l.id}><td className="tabular-nums whitespace-nowrap">{fmt(l.at)}</td><td className="font-semibold">{l.operation}</td><td className="font-mono text-[11px] o-muted">{l.endpoint}</td><td className="tabular-nums">{l.duration_ms} ms</td><td><OrbitStatus label={l.status === "ok" ? "OK" : "Erreur"} color={l.status === "ok" ? "green" : "red"} /></td><td className="tabular-nums">{l.count}</td><td className="text-[11.5px]" style={{ color: "var(--orbit-red)" }}>{l.error || ""}</td></tr>)}
          {rows && rows.length === 0 && <tr><td colSpan={7}><OrbitEmptyState title="Aucune opération journalisée" /></td></tr>}</tbody></table>
    </OrbitPanel>
  );
}
